module.exports = __webpack_public_path__ + "static/img/6.c70e618.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/6.png
// module id = U6P3
// module chunks = 0